import React from "react";
import GooLoader from "../../Components/GooLoader/GooLoader";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import { Helmet } from "react-helmet-async";
import jwt_decode from "jwt-decode";
import "./NotInBusiness.css";

class NotInBusiness extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleBack = this.handleBack.bind(this);
    this.handleBackHome = this.handleBackHome.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (decoded.active) {
        this.props.history.push("/dashboard");
      } else {
        if (
          this.props.location.state === undefined ||
          !this.props.location.state.userData
        ) {
          this.props.history.push("/");
        } else {
          let userData = this.props.location.state.userData;
          const { user_type } = userData;
          if (!user_type || user_type !== "OTHER") {
            this.props.push("/for-founders-by-founders", {
              userData: userData,
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        }
      }
    }
  }

  handleBackHome() {
    localStorage.clear();
    this.props.history.push("/");
  }

  handleBack() {
    this.props.history.goBack();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-founders-not-in-business"
          hasCounter={false}
          hasQuote={true}
          quote={
            <span>
              We’re building a community of entrepreneurs. <br />
              Circle back when you’re ready to take that leap!
            </span>
          }
          headerText="Maybe next time"
          primaryButtonText="Go to home"
          showButton={true}
          handlePrimaryBtnOnClick={this.handleBackHome}
          activatePrimaryWithEnter={true}
          showBackButton={true}
          backButtonText="Back"
          handleBackButtonClick={this.handleBack}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default NotInBusiness;
